<div class="table-container">
  <div class="table-utils" *ngIf="showUtils">
    <div class="table-count">
      {{columnRowData.length}} relays found
    </div>
    <div class="utils" >
      <div class="util-drpdown">
        <select class="form-control nr-select">
          <option class="option-data">Export as....</option>
        </select>
      </div>
      <div class="util-drpdown">
        <select class="form-control nr-select">
          <option>Customize</option>
        </select>
      </div>


    </div>
  </div>
  <div class="table-section">
    <div class="refresh-table prt" *ngIf="showResetFilter" (click)="resetGrid()"><a>Reset Filter</a></div>
    <table class="table table-striped nr-table" id="excel-table">
      <thead>
        <tr >
          <!-- <ng-container *ngIf="showCheckbox">
            <th > <input style="margin-left: 12px;" class="hideContent" type="checkbox" /></th>
          </ng-container> -->

          <th scope="col" *ngFor="let header of columnHeader; let i = index" (click)="sortData(header)">
            <div class="table-header">
              <div class="col-text" [ngClass]= "{'prt': header.isSortable == true}">
                <span>
                  {{header.title}}
                </span>
              </div>
              <div class="filter-img" #sortTh [ngClass]= "{'hideContent': header.isSearchable == false}">
                <span (click)="showFilter($event,header,i)"  class="prt">
                  <img *ngIf="!header.isFilterd" src="assets/images/TableColumn.png" class="arrow" alt="up arrow" />
                  <img *ngIf="header.isFilterd" src="assets/images/filter-table.png" class="filter-icn" alt="up arrow" />
                </span>
              </div>
            </div>

          </th>

        </tr>
      </thead>
      <tbody>

      <ng-container *ngIf="splicedData">
        <tr  *ngFor="let data of splicedData" [ngClass]= "{'prt': isRowClickable == true}" (click)="selectedRowDetails(data)">
          <!-- <ng-container *ngIf="showCheckbox">
            <td> <input type="checkbox"
              (change)="checkOrUncheckSelected(data, $event.target.checked)"/>
            </td>
          </ng-container> -->

          <td *ngFor="let col of columnHeader; let i = index" [ngClass]="col.class">
            <!-- <ng-container *ngIf="i == 0">
                <input type="checkbox" />
            </ng-container> -->
            <ng-container *ngIf="!dynamicContent(col)" >
              <span >{{getData(data, col.id)}}</span>
            </ng-container>
            <ng-container *ngIf="dynamicContent(col)">
              <ng-container *ngTemplateOutlet="dynamicContent(col);context:{column :col,  rowData: data, parentDataIndex: index,
                viewData:getData(data, col.id)} ">
              </ng-container>
            </ng-container>
            <div>

            </div>
          </td>
        </tr>
      </ng-container>
       <ng-container *ngIf="splicedData.length == 0".>
          <tr>
            <td class="no-content" [attr.colspan]="getColumnLength()">No data found</td>
          </tr>
       </ng-container>

      </tbody>
    </table>
  </div>

  <div class="table-paginator" *ngIf="splicedData.length !== 0">
    <mat-paginator #paginator [pageSizeOptions]="pageSizeOptions" style-paginator [showTotalPages]="4"
      [length]="columnRowData.length" [pageSize]="pageSize" (page)="getPaginatorData($event)"  >
     </mat-paginator>
  </div>

</div>


<div *ngIf="showLoader" class="loader">
  <mat-spinner strokeWidth ="3" diameter="100" color="#000"></mat-spinner>
</div>


<!--Column search modal-->


<!-- The filter popup -->
<div class="filter-container" >
  <div class="filter-container-position" >
    <app-table-filter-search *ngIf="showFilterPopUp" [searchLabel]="searchLabel" [columnRowData]="columnRowData"
    [objPosition]="objPosition" [columnRowDataBackup]="columnRowDataBackup" (closeFilterOverlay)="closeFilter($event)"  (searchKeyword)="tableSearch($event)"></app-table-filter-search>
  </div>
</div>
